import React, { useReducer } from 'react';
import { Content, ExpandableContainer } from 'components';
import { Button, DatePicker, Input, Select } from 'antd';
import { styles } from '../styles';
import dayjs from 'dayjs';

const FindSearchWord = ({ onChange }) => {
  const today = dayjs();
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'CHANGE_VISIBLE':
          return {
            ...state,
            is_visible: action.value,
          };
        case 'CHANGE_DATES':
          return {
            ...state,
            dates: action.value,
          };
        case 'CHANGE_SEARCH_WORD':
          return {
            ...state,
            search_word: action.value,
          };
        case 'RESET':
          return {
            is_visible: 'all',
            dates: [null, null],
            search_word: '',
          };
        default:
          throw new Error(`${action.type}을 찾을 수 없습니다.`);
      }
    },
    {
      is_visible: 'all',
      dates: [null, null],
      search_word: '',
    }
  );

  const handleChangeDate = (type) => {
    switch (type) {
      case 'TODAY':
        dispatch({
          type: 'CHANGE_DATES',
          value: [today.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')],
        });
        return;
      case '1WEEK':
        dispatch({
          type: 'CHANGE_DATES',
          value: [
            today.subtract(7, 'day').format('YYYY-MM-DD'),
            today.format('YYYY-MM-DD'),
          ],
        });
        return;
      case '1MONTH':
        dispatch({
          type: 'CHANGE_DATES',
          value: [
            today.subtract(1, 'month').format('YYYY-MM-DD'),
            today.format('YYYY-MM-DD'),
          ],
        });
        return;
      case '3MONTH':
        dispatch({
          type: 'CHANGE_DATES',
          value: [
            today.subtract(3, 'month').format('YYYY-MM-DD'),
            today.format('YYYY-MM-DD'),
          ],
        });
        return;
      case 'ALL':
        dispatch({ type: 'CHANGE_DATES', value: [null, null] }); // 전체는 빈 문자열로 처리
        return;
      default:
        throw new Error(`${type}는 유효하지 않은 날짜 타입입니다.`);
    }
  };

  const handleSearch = () => {
    onChange(state);
  };

  const formItem = [
    {
      label: '노출여부',
      form: [
        {
          input: (
            <Select
              size="large"
              value={state.is_visible}
              onChange={(value) =>
                dispatch({ type: 'CHANGE_VISIBLE', value: value })
              }
              options={[
                { label: '전체', value: 'all' },
                { label: '노출됨', value: 'is_visible' },
                { label: '노출안됨', value: 'in_visible' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '등록일자',
      form: [
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('TODAY')}
            >
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('1WEEK')}
            >
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('1MONTH')}
            >
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('3MONTH')}
            >
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('ALL')}
            >
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                value={state.dates[0] && dayjs(state.dates[0])}
                onChange={(value) => {
                  if (value) {
                    dispatch({
                      type: 'CHANGE_DATES',
                      value: [value.format('YYYY-MM-DD'), state.dates[1]],
                    });
                  } else {
                    dispatch({
                      type: 'CHANGE_DATES',
                      value: ['', state.dates[1]],
                    });
                  }
                }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                value={state.dates[1] && dayjs(state.dates[1])}
                onChange={(value) => {
                  if (value) {
                    dispatch({
                      type: 'CHANGE_DATES',
                      value: [state.dates[0], value.format('YYYY-MM-DD')],
                    });
                  } else {
                    dispatch({
                      type: 'CHANGE_DATES',
                      value: [state.dates[0], ''],
                    });
                  }
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '추천검색어 명',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="추천 검색어를 입력해주세요"
                value={state.search_word}
                onChange={(e) =>
                  dispatch({
                    type: 'CHANGE_SEARCH_WORD',
                    value: e.target.value,
                  })
                }
                style={{ ...styles.form.input.large }}
              />
            </>
          ),
        },
      ],
    },
  ];

  return (
    <Content
      maxWidth={'100%'}
      padding={0}
      backgroundColor={'none'}
      style={{ marginBottom: 20 }}
    >
      <ExpandableContainer borderRadius={4} padding={20}>
        {formItem.map((_item, _index) => (
          <div
            key={`form_${_index}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px 0px',
            }}
          >
            <div style={{ minWidth: 120, fontSize: 13, fontWeight: 400 }}>
              <label>{_item.label}</label>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {_item.form.map((_subitem, _subkey) => (
                <React.Fragment key={`input_${_subkey}`}>
                  {_subitem.input}
                </React.Fragment>
              ))}
            </div>
          </div>
        ))}
      </ExpandableContainer>
      {/* 검색/초기화 버튼 */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          marginTop: 48,
        }}
      >
        <Button
          size="large"
          type="primary"
          style={{ ...styles.button, background: 'var(--primary-color)' }}
          onClick={handleSearch}
        >
          검색
        </Button>
        <Button
          size="large"
          style={{ ...styles.button }}
          onClick={() => {
            dispatch({ type: 'RESET' });
            onChange({
              is_visible: 'all',
              dates: [null, null],
              search_word: '',
            });
          }}
        >
          초기화
        </Button>
      </div>
      {/* 검색/초기화 버튼 끝 */}
    </Content>
  );
};

export default FindSearchWord;
